<!-- <div class="">
    <mat-dialog-content class="">
        <div class="font-14 heading">
            <h4>{{ data?.message }}</h4>
        </div>
        <div class="assessment_py-10 font-8">
            {{ data?.message2 }}
        </div>
        <form [formGroup]="form">
     <div class="form-group phn-input">
        <input class="form-control" type="password" formControlName="new_password" placeholder="New Password" password>
     </div>
     <div class="form-group phn-input">
        <input class="form-control" type="password" formControlName="confirm_password" placeholder="Confirm Password" password>
     </div>
     <button class="btn btn-primary btn-block" type="button">RESET PASSWORD</button>

        </form>
    </mat-dialog-content>

</div> -->

<div class="">
  <mat-dialog-content style="scroll-behavior: unset">
    <p class="stepDisplay">
      <!-- <a router-Link="/">
            <img src="assets//img/back-arrow-icon-dark.svg" alt="STEP 1/4"/></a> -->
    </p>

    <div class="font-14 heading">
      <h4
        style="
          font-family: 'MontSerrat';
          color: #1e2a36;
          font-weight: 600;
          font-size: 24px;
        "
      >
        {{ data?.message }}
      </h4>
    </div>
    <div class="assessment_py-10 font-8">
      <h6
        style="
          font-family: 'MontSerrat';
          font-weight: 500;
          font-size: 16px;
          color: #748494;
        "
      >
        {{ data?.message2 }}
      </h6>
    </div>
    <form [formGroup]="setPasswordForm" (submit)="resetPassword()">
      <div class="setup-account-input-icons">
        <img
          class="setup-account-icon"
          src="assets/img/password-lock.svg"
          alt=""
        />
        <input
          oncopy="return false"
          onpaste="return false"
          class="form-control setup-account-input-field-left"
          [type]="show_button ? 'text' : 'password'"
          formControlName="newPassword"
          placeholder="Password"
        />
        <mat-error
          class="error-msg"
          *ngIf="p.newPassword.touched && p.newPassword.errors?.required"
        >
          Required
        </mat-error>
        <mat-error
          class="error-msg"
          *ngIf="
            p.newPassword.touched &&
            !p.newPassword.errors?.required &&
            (p.newPassword.errors?.minlength || p.newPassword.errors?.pattern)
          "
        >
        Password should contain at least 6 characters(should contain A-Z,
        a-z, and 0-9)
        </mat-error>

        <mat-icon
          class="font-16 cursor-pointer field-icon"
          matSuffix
          (click)="showPassword()"
          >{{ show_button ? "visibility_off" : "visibility" }}</mat-icon
        >
      </div>
      <div class="setup-account-input-icons" style="margin-bottom: 35px">
        <img
          class="setup-account-icon"
          src="assets/img/password-lock.svg"
          alt=""
        />
        <input
          oncopy="return false"
          onpaste="return false"
          class="form-control setup-account-input-field-left"
          [type]="show_eye ? 'text' : 'password'"
          formControlName="confirmPassword"
          placeholder="Confirm Password"
          phone-number
        />
        <mat-error
          class="error-msg"
          *ngIf="
            p.confirmPassword.touched && p.confirmPassword.errors?.required
          "
        >
          Required
        </mat-error>

        <!-- <a (click)="showConfirmPassword()"><img style="left:900px;top:355px;" src="assets/img/password-eye.svg" alt="" /></a> -->
        <mat-icon
          class="font-16 cursor-pointer field-icon"
          matSuffix
          (click)="showConfirmPassword()"
          >{{ show_eye ? "visibility_off" : "visibility" }}</mat-icon
        >
        <mat-error
          class="error-msg"
          *ngIf="
            p.confirmPassword.touched && !p.confirmPassword.errors?.required && !isPasswordEqualToConfirmPassword()
          "
        >
          The passwords don’t match, please try again
        </mat-error>
      </div>

      <div class="assessment_pt-10">
        <button class="btn btn-primary btn-block" type="submit">
          RESET PASSWORD
        </button>
      </div>
    </form>
  </mat-dialog-content>
</div>
